import React,{FC,useState,useEffect,useRef} from 'react';
import {useNavigate,useLocation,HashRouter,Routes,Route,useParams} from 'react-router-dom';
import logo from './logo.svg';
import { useThrottleFn } from 'ahooks'
import { Button, NavBar, TabBar,SideBar,Toast,List } from 'antd-mobile'
import {
    AppOutline,
    MessageOutline,
    UnorderedListOutline,
    UserOutline,
} from 'antd-mobile-icons'
import './App.css';
import './demo2.css'
import axios from 'axios';
import Bottom from "./Bottom";
const About: FC = (props) => {
    const [art,setArt]=useState({title:'',content:''});
    let params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { pathname } = location;
    console.log(location);
    useEffect(()=>{
        Toast.show({icon:'loading',content:'加载中...',maskClickable: false,duration:30000});
        // @ts-ignore
        axios({
            method:'post',url:'/data/article/show',data:{skey:'7lOomnwevsCUuo6M'},reponseType:'json'
        }).then(function(response){
            Toast.clear();
            let json=response.data;
            if(json.success){
                setArt(json.data.art);
            }else{
                Toast.show({icon:'fail',content:json.message});
            }
        }).catch(function(error){
            console.log(error)
            Toast.show({icon:'fail',content:'系统错误，请稍候再试'});
        });

    },[]);
    return (<div className='app'>
        <div className='top'>
            <NavBar back={null}>{art.title}</NavBar>
        </div>
        <div className='body page-prescription'>
            <div className='art-content'>
                <div dangerouslySetInnerHTML={{__html:art.content}} />
            </div>
        </div>
        <div className='bottom'>
            <Bottom></Bottom>
        </div>
    </div>)
}

export default  About;